import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiRoutes } from "../../../utils/ApiRoutes";
import { getUserKeysApi } from "../../apis";
import { addAllBusinessApi, addBusinessApi, addGbpBusinessApi, deleteBusinessApi, getBusinessApi, getGbpBusinessPaginatedApi } from "../../apis/UserApis/LocalBusinessApi";
import { showSnackbar } from "../../slices/SnackbarSlice";
import { IAddBusinessData } from "../../apis/IApisInterface";

const USER_KEYS = apiRoutes?.userKeys
const GET_BUSINESS = apiRoutes?.getBusiness

export const getUserKeysAction = createAsyncThunk(USER_KEYS, async (_, { rejectWithValue }) => {
    try {
        const response = await getUserKeysApi()
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not get user keys" })
    }
})

export const getBusinessAction = createAsyncThunk(GET_BUSINESS, async (_, { rejectWithValue }) => {
    try {
        const response = await getBusinessApi()
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "get all business successfully" })
    }
})

export const addBusinessAction = createAsyncThunk("add/business", async (placeId: IAddBusinessData, { rejectWithValue, dispatch }) => {
    try {
        const response = await addBusinessApi(placeId)
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error || { message: "Could not add business" });
    }
})

export const addAllBusinessAction = createAsyncThunk("add/multiple/business", async (placeIds: string[], { rejectWithValue, dispatch }) => {
    try {
        const response = await addAllBusinessApi(placeIds)
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error || { message: "Could not add all business" });
    }
})

export const deleteBusinessAction = createAsyncThunk("delete/business", async (id: string, { rejectWithValue, dispatch }) => {
    try {
        const response = await deleteBusinessApi(id)
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error?.response?.data || { message: "Could not delete business" })
    }
})

// export const getGbpBusinessAction = createAsyncThunk("/get/gbp/business", async ( _, { rejectWithValue }) => {
//     try {
//         const response = await getGbpBusinessApi()
//         return response.data
//     } catch (error: any) {
//         return rejectWithValue(error?.response?.data || { message: "get all gbp business successfully" })
//     }
// })

export const getGbpBusinessPaginatedAction = createAsyncThunk("/get/gbp/business-paginated", async (payload: { page: number, limit: number, keyword: string, email: string, sort_by?: string, sort_order?: string }, { rejectWithValue }) => {
    try {
        const response = await getGbpBusinessPaginatedApi(payload)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "get all gbp business paginated successfully" })
    }
})

export const addGbpBusinessAction = createAsyncThunk("add/gbp/business", async (token: string, { rejectWithValue, dispatch }) => {
    try {
        const response = await addGbpBusinessApi(token)
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error || { message: "Could not add gbp business" });
    }
})